import FullDayEventTimeslot from "../../full-day-event-timeslot/FullDayEventTimeslot";
import getClasses from "utils/getClasses";
import styles from "../ScrollableCalendarViewHeader.module.scss";
import { FullDayEventSlotItem } from "../ScrollableCalendarViewHeader.types";
import TimeslotTitle from "../../timeslot-title/TimeslotTitle";
import { Button } from "react-bootstrap";

interface FullDayEventSlotCellProps {
  colSpan?: number;
  children?: React.ReactNode;
}

interface FullDayEventSlotProps {
  item: FullDayEventSlotItem;
  onExpandClick: () => void;
}

const FullDayEventSlotCell = ({
  colSpan = 1,
  children = null,
}: FullDayEventSlotCellProps) => (
  <th colSpan={colSpan}>
    <div className={getClasses(styles["th-body"], styles["th-body--events"])}>
      <div className={styles["event-container"]}>{children}</div>
    </div>
  </th>
);

const FullDayEventSlot = ({ item, onExpandClick }: FullDayEventSlotProps) => {
  switch (item.type) {
    case "EMPTY": {
      return <FullDayEventSlotCell />;
    }
    case "EVENT_START": {
      const { event, lengthInDays, eventType } = item;
      return (
        <FullDayEventSlotCell colSpan={lengthInDays}>
          <FullDayEventTimeslot event={event} eventType={eventType} />
        </FullDayEventSlotCell>
      );
    }
    case "EXPAND_PROMPT": {
      const label = `${item.moreEvents} more`;
      return (
        <FullDayEventSlotCell>
          <Button
            tabIndex={0}
            variant={"light"}
            className={styles["more"]}
            title={label}
            onClick={onExpandClick}
          >
            <TimeslotTitle>{label}</TimeslotTitle>
          </Button>
        </FullDayEventSlotCell>
      );
    }
    case "EVENT_CONTINUED":
    default: {
      return null;
    }
  }
};

export default FullDayEventSlot;
